import { atom } from "jotai";
import {
  subConditionsCountQueryAtom,
  superConditionsCountQueryAtom,
} from "../../services/queries";

export const subConditionsCountState = atom(
  (get) => get(subConditionsCountQueryAtom).data || 0
);
export const superConditionsCountState = atom(
  (get) => get(superConditionsCountQueryAtom).data || 0
);
